import api from '../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const manufacturersStartRequest = () => {
  return {
    type: 'MANUFACTURERS_START_REQUEST'
  };
};

export const manufacturersEndRequest = () => {
  return {
    type: 'MANUFACTURERS_END_REQUEST'
  };
};

export const getAllManufacturersSuccess = ({ data }) => {
  return {
    type: 'MANUFACTURERS_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllManufacturersError = error => {
  return {
    type: 'MANUFACTURERS_GET_ALL_ERROR',
    payload: error
  };
};

export const addManufacturersSuccess = ({ data }) => {
  return {
    type: 'MANUFACTURERS_ADD_SUCCESS',
    payload: data
  };
};

export const addManufacturersError = error => {
  return {
    type: 'MANUFACTURERS_ADD_ERROR',
    payload: error
  };
};

export const editManufacturersSuccess = ({ data }) => {
  return {
    type: 'MANUFACTURERS_EDIT_SUCCESS',
    payload: data
  };
};

export const editManufacturersError = error => {
  return {
    type: 'MANUFACTURERS_EDIT_ERROR',
    payload: error
  };
};

export const removeManufacturersSuccess = id => {
  return {
    type: 'MANUFACTURERS_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeManufacturersError = error => {
  return {
    type: 'MANUFACTURERS_REMOVE_ERROR',
    payload: error
  };
};

export const manufacturersModifyStore = ({ data }) => {
  return {
    type: 'MANUFACTURERS_MODIFY_STORE',
    payload: data
  };
};

export const addManufacturers = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(manufacturersStartRequest());
      const response = await api().post('/api/manufacturers', data);
      dispatch(addManufacturersSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'manufacturers',
        data: [response.data],
        company: response.data.company
      });
      formReset();
    } catch (err) {
      dispatch(addManufacturersError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(manufacturersEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllManufacturers = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(manufacturersStartRequest());
      const response = await api().get('/api/manufacturers', { params });
      dispatch(getAllManufacturersSuccess(response));
    } catch (err) {
      dispatch(getAllManufacturersError(err));
    } finally {
      dispatch(manufacturersEndRequest());
    }
  };
};

export const editManufacturers = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(manufacturersEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(manufacturersStartRequest());
      const id = data._id;
      const response = await api().put('/api/manufacturers/' + id, data);
      dispatch(editManufacturersSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'manufacturers',
        data: [response.data],
        company: response.data.company
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/manufacturers'));
      }
    } catch (err) {
      dispatch(editManufacturersError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeManufacturers = id => {
  return async dispatch => {
    try {
      dispatch(manufacturersStartRequest());
      await api().delete('/api/manufacturers/' + id);
      dispatch(removeManufacturersSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'manufacturers',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Fabricante removido com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeManufacturersError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover fabricante.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(manufacturersEndRequest());
    }
  };
};

export const restoreManufacturers = data => {
  return async dispatch => {
    try {
      dispatch(manufacturersStartRequest());
      const id = data._id;
      const response = await api().put('/api/manufacturers/' + id, data);
      dispatch(editManufacturersSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'manufacturers',
        data: [response.data],
        company: response.data.company
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Fabricante restaurado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editManufacturersError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar fabricante.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(manufacturersEndRequest());
    }
  };
};
